import { Add, Comment } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  List,
  Typography,
} from "@mui/material";
import { ProcessedEventData } from "../../../types/EventData.types";
import EventDataItem from "../EventDataItem";

interface CommunicationCardProps {
  events: ProcessedEventData[];
  onAddComment: () => void;
  workId?: number;
}

const CommunicationCard = ({
  events,
  onAddComment,
  workId,
}: CommunicationCardProps) => {
  return (
    <Card elevation={2}>
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            variant="h6"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Comment />
            Timeline ({events.length})
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<Add />}
            onClick={onAddComment}
            sx={{ borderRadius: 2 }}
          >
            Lägg till kommentar
          </Button>
        </Box>

        {events.length > 0 ? (
          <List disablePadding>
            {events.map((event, index) => (
              <EventDataItem
                key={event.Id}
                event={event}
                isLast={index === events.length - 1}
                workId={workId}
              />
            ))}
          </List>
        ) : (
          <Box
            sx={{
              textAlign: "center",
              py: 3,
              color: "text.secondary",
            }}
          >
            <Typography variant="body2">
              Inga kommentarer eller kommunikation registrerad ännu.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Klicka på "Lägg till kommentar" för att börja.
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default CommunicationCard;
